export interface CreateSynonymGroupRequest {
  data: string[]
}

export function CreateSynonymGroupRequestToJSON(
  value: CreateSynonymGroupRequest
): any {
  return {
    data: value.data.length > 0 ? value.data : undefined
  }
}
